import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import LogoutModal from "../components/LogoutModal";
import Meta from "../components/Meta";
// eslint-disable-next-line
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import api from "../services/api";

import SescServices from "../services/handleSesc";
import Loader from "../components/Loader";
import ImagemTC from "../assets/credencial_plena.png";
import PerfilCV from "../assets/perfil.png";

import ImagemPG from "../assets/credencial_atividades.png";
import ImagemConv from "../assets/credencial_convenio.png"; // Tipo 4
import ImagemConvDep from "../assets/credencial_convenio.png"; // Tipo 5


// eslint-disable-next-line
import QRCode from "qrcode.react";
import Barcode from "react-barcode";

import { Button, Modal, Table } from "react-bootstrap";

const CredencialDepScreen = () => {
  const [show, setShow] = useState(false);
  // eslint-disable-next-line
  const [loading, setLoading] = useState(false);
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const [users, setUsers] = useState([]);
  const [dtAtual, setAtual] = useState("");
  const [clientela, setClientela] = useState("");
  const [matricula, setMatricula] = useState([]);
  const [matriculaVia, setMatriculaVia] = useState("");
  const [vencimento, setVencimento] = useState([]);
  const [via, setVia] = useState("");
  const [foto, setFoto] = useState("");
  const [perfil, setPerfil] = useState("");
  const [tipo, setTipo] = useState("");
  const [dtNascimento, setDtNascimento] = useState("");


  const [categoria, setCategoria] = useState("");
  const [tipoCategoria, setTipoCategoria] = useState("");

  // eslint-disable-next-line
  const [sqtitulmat, setSQtitulmat] = useState("");

  // eslint-disable-next-line
  const [cardVenc, setCardVenc] = useState(false);

  function hexToBase64(hexstring) {
    return btoa(
      hexstring
        .match(/\w{2}/g)
        .map(function (a) {
          return String.fromCharCode(parseInt(a, 16));
        })
        .join("")
    );
  }

  const handlerAcesso = async (cpf, id) => {
    try {
      //const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      const resp_dep = await SescServices.helper3_dep(cpf);
      const config = { headers: { "Content-Type": "application/json" } };

      await api.post(
        "/api/usersDep/",
        {
          user_id: id,
          cpf: resp_dep.NUCPF,
          nome: resp_dep.NMCLIENTE,
          matricula: resp_dep.MATFORMAT,
        },
        config
      );
      toast.success("Solicitação feita com sucesso!");
    } catch (error) {
      const err =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      toast.error(err);
    }
  };

  const handlerFicha = async (cpf) => {
    const resp = await SescServices.helper3_dep(cpf);
    setShow(true);

    setSQtitulmat(resp.SQTITULMAT);
    setClientela(resp.NMCLIENTE);
    setVia(resp.NRVIACART);

    let splitsMat = resp.MATFORMAT.split("-");
    setMatricula(splitsMat);

    let matvia = splitsMat.join("");
    setMatriculaVia(matvia.trim());

    const dtAtual = new Date().toISOString().slice(0, 10);
    if (resp.DTVENCTO < dtAtual) {
      setCardVenc(true);
    }

    let dtVenc = resp.DTVENCTO;
    let splits = dtVenc.split("-");
    setVencimento(splits);
    resp.FOTO2 != null ? setFoto(hexToBase64(resp.FOTO2)) : setPerfil(PerfilCV);

    setTipo(resp.TPCATEGORI);
    let dtNasc = resp.DTNASCIMEN;
    let splitsDt = dtNasc.split("-");
    setDtNascimento(splitsDt);

    setCategoria(resp.DSCATEGORI);
    setTipoCategoria(resp.CDCATEGORI);
  };

  //CONFIRMAÇÃO DO PESQUISA DA CRENDENCIAL
  const pesquisa = async () => {
    const todayDate = new Date().toISOString().slice(0, 10);
    setAtual(todayDate);

    const resp = await SescServices.helperDep(userInfo);
    setUsers(resp);
  };

  useEffect(() => {
    // eslint-disable-next-line
    setLoading(true);
    if (userInfo) {
      pesquisa();
      setTimeout(function () {
        /*código a ser executado no tempo informado*/
        setLoading(false);
      }, 1000);
    }

    // eslint-disable-next-line
  }, []);






  const getBackgroundStyle = (backgroundImage) => {
    let backgroundSize = "auto";
    let backgroundPosition = "top center";

    if (tipo === 4 || tipo === 5) {
      backgroundSize = "cover";
      backgroundPosition = "center top";
    }

    return {
      backgroundImage: `url(${backgroundImage})`,
      backgroundRepeat: "no-repeat",
      backgroundSize,
      backgroundPosition,
      width: "390px",
      height: "800px",
      color: "#000000",
    };
  };










  return (
    <>
      <ToastContainer />
      <Meta />

      <div id="wrapper">
        <Sidebar />

        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Navbar />

            {loading ? (
              <Loader />
            ) : (
              <>
                <div className="container-fluid">
                  <div className="d-sm-flex align-items-center justify-content-between mb-4">
                    <h1 className="h3 mb-0 text-gray-800">
                      Credencial Virtual dos Dependentes
                    </h1>
                  </div>

                  <Table striped bordered hover responsive className="table-sm">
                    <thead>
                      <tr>
                        <th className="text-center">NOME</th>
                        <th className="text-center">MATRICULA</th>
                        <th className="text-center">VENCIMENTO</th>
                        <th className="text-center">SOLICITAR VALIDAÇÃO?</th>
                        <th className="text-center">CREDENCIAL</th>
                      </tr>
                    </thead>
                    <tbody>
                      {users.map((user, index) => (
                        <tr key={index}>
                          {user.SQTITULMAT != null ? (
                            <>
                              <td style={{ width: "25%" }}>{user.NMCLIENTE}</td>
                              <td className="text-center">{user.MATFORMAT}</td>

                              <td className="text-center">{user.DTVENCTO}</td>
                              <td className="text-center">
                                {/*
                                  AÇÕES 
                                
                                */}

                                {dtAtual > user.DTVENCTO ? (
                                  <Button
                                    variant="primary"
                                    className="btn-sm"
                                    onClick={(e) => {
                                      if (
                                        window.confirm(
                                          "Tem certeza que deseja fazer a solicitação ?"
                                        )
                                      ) {
                                        handlerAcesso(user.NUCPF, userInfo._id);
                                      }
                                    }}
                                  >
                                    <i className="far fa-paper-plane mr-2"></i>
                                    SOLICITAR
                                  </Button>
                                ) : (
                                  <Button
                                    variant="light"
                                    className="btn-sm"
                                    disabled
                                  >
                                    <i className="far fa-paper-plane mr-2"></i>
                                    SOLICITAR
                                  </Button>
                                )}
                              </td>
                              <td className="text-center">
                                {dtAtual < user.DTVENCTO ? (
                                  <Button
                                    variant="success"
                                    className="btn-sm"
                                    onClick={() => {
                                      handlerFicha(user.NUCPF);
                                    }}
                                  >
                                    <i className="far fa-address-card mr-2"></i>
                                    CREDENCIAL
                                  </Button>
                                ) : (
                                  <Button
                                    variant="success"
                                    className="btn-sm"
                                    disabled
                                  >
                                    <i className="far fa-address-card mr-2"></i>
                                    CREDENCIAL
                                  </Button>
                                )}
                              </td>
                            </>
                          ) : null}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </>
            )}
          </div>

          <Footer />
        </div>
      </div>
      <LogoutModal />

      <Modal
        show={show}
        onHide={() => setShow(false)}
        //dialogClassName="modal-70w"
        aria-labelledby="example-custom-modal-styling-title"
        size="lg"
        className="conteudo"
        id="print"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            <h5 className="modal-title" id="exampleModalLongTitle">
              Cartão Virtual do Dependente
            </h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-xl-3 col-md-12 mb-4">
              <div style={getBackgroundStyle(
                tipo === 2
                  ? ImagemPG
                  : tipo === 5
                    ? ImagemConvDep
                    : ImagemTC
              )}>

                {/* Foto do usuário */}
                <div className="text-center" style={{ paddingTop: "110px" }}>
                  {foto ? (
                    <img
                      src={`data:image/png;base64,${foto}`}
                      className="rounded-circle"
                      width="150"
                      height="150"
                      alt="perfil"
                    />
                  ) : (
                    <img
                      src={perfil}
                      className="rounded-circle"
                      width="150"
                      height="150"
                      alt="perfil"
                    />
                  )}
                </div>

                {/* Nome e nascimento */}
                <div className="text-center" style={{ paddingTop: "60px" }}>
                  <strong style={{ fontSize: "14px" }}>{clientela}</strong>
                  <br />
                  {`${dtNascimento[2]}/${dtNascimento[1]}/${dtNascimento[0]}`}
                </div>

                {/* Imagem central */}
                <div className="text-center">
                  <img
                    src={
                      tipo === 2
                        ? "/img/IMG_PGDEP.png"
                        : tipo === 5
                          ? "/img/IMG_CONVDEP.png"
                          : "/img/IMG_TCDEP.png"
                    }
                    width="215"
                    height="93"
                    alt="fundo"
                  />
                </div>

                {/* Matrícula e código de barras */}
                <div className="text-center">
                  {matricula.join("-")}
                  <br />
                  {[36, 37, 11, 43, 59, 60].includes(tipoCategoria) && (
                    <p>{categoria}</p>
                  )}

                  <Barcode
                    value={via + matriculaVia}
                    displayValue={true}
                    background={tipo === 2 ? "#d1d3d4" : tipo === 5 ? "#e9e9e9" : "#ffbd00"}
                    fontSize={12}
                    format="CODE128"
                  />
                </div>

                {/* Validade */}
                <div className="text-center" style={{ paddingTop: "4px" }}>
                  Validade nacional: {`${vencimento[1]}/${vencimento[0]}`} <br />
                  <strong>Departamento Regional de Alagoas</strong>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>

      </Modal>
    </>
  );
};

export default CredencialDepScreen;
